module.exports = __webpack_public_path__ + "static/media/tb_app_icon_edit_sequence.4e6d2b49.svg";